import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box sx={{ bgcolor: 'background.dark', color: 'white', py: 4 }}>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          gap: 3, 
          flexDirection: { xs: 'column', sm: 'row' }, 
          textAlign: { xs: 'center', sm: 'left' } 
        }}>
          <img 
            src="/images/logo_w.svg" 
            alt="Webigram Logo" 
            style={{ height: 60 }} 
          />
          <img 
            src="/images/univerpredprenimatelstvologo.png" 
            alt="Платформа университетского технологического предпринимательства" 
            style={{ height: 80, maxWidth: 200, objectFit: 'contain' }} 
          />
          <Typography variant="body2" sx={{ opacity: 0.7, maxWidth: '850px' }}>
            Проект создан при поддержке <Link href="https://fasie.ru" target="_blank" rel="noopener noreferrer" color="inherit">Федерального государственного бюджетного учреждения Фонд содействия развитию малых форм предприятий в научно-технической сфере</Link> в рамках программы <Link href="https://univertechpred.ru/" target="_blank" rel="noopener noreferrer" color="inherit">«Студенческий стартап» федерального проекта «Платформа университетского технологического предпринимательства»</Link>.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;